// **** import modules ****
import $ from "jquery";
import moment from "moment";
import app, { Klass, vuwer } from "@@assets/scripts/common";
import "@@assets/klass/InstagramModule";


// **** process ****
vuwer.add("instagramSection", {
	selector: "#instagram_section",
	onReadyLast($self) {
		if(!$self) {
			return false;
		}
		
		const dataList = this.get("dataList");
		const count = dataList.module.items.length || 0;
		$self.attr({ "data-count": count });
	}
	
}, function() {
	// [add child vuw]
	this
	// define [dataList]
	.add("dataList", {
		selector: "#data_list_instagram",
		
		module: Klass.new_("InstagramModule", {
			app,
			itemFilter(i, item) {
				if(item.timestamp) {
					item.timestamp = moment(item.timestamp);
				}
			}
		}),
		
		async onReadyFirst($self) {
			if(!$self) {
				return false;
			}
			
			await this._promise;
			
			const { list } = this.module.items;
			if( !Array.isArray(list) ) {
				return false;
			}
			
			$.fn.append.apply(
				$self,
				list.map(item => this.initArticle(item, this.module))
			);
			
			return this;
		},
		
		initArticle(item, module) {
			const imgSrc = item.thumbnail_url || item.media_url;
			if(!imgSrc) {
				return false;
			}
			
			const { permalink, media_type, timestamp, caption } = item;
			const $timestamp = !timestamp.isValid() ? "" : $("<p/>").addClass("date").text(
				timestamp.format("YYYY.MM.DD")
			);
			const $caption = !caption ? null : $("<p/>").addClass("caption").html(
				caption.replace(/\n/g, "<br>")
			);
			
			const $article = $("<a>").addClass("data-article").attr({
				"href": permalink,
				"target": "_blank",
				"data-media-type": media_type.toLowerCase(),
				"data-key": module.getDataKey()
			}).css({
				"background-image": `url(${imgSrc})`
			}).append($timestamp, $caption);
			
			return $article;
		}
	}, function() {
		this.module.vuw = this;
		this._promise = this.module.getRecent(4);
		
		// appから直接アクセス可能にする
		app.instagram = this.module;
	});
});
